import { clearCanvas, drawGrid, normalizeRange, setupCanvas } from './canvas-utils';

export function renderLineChart(canvas: HTMLCanvasElement, values: number[], color: string = '#5aa6ff'): void {
    const setup = setupCanvas(canvas);
    if (!setup) return;
    const { ctx, width, height } = setup;

    clearCanvas(ctx, width, height);
    drawGrid(ctx, width, height, 4, 4, 'rgba(255,255,255,0.08)');

    if (values.length < 2) return;
    const { min, max } = normalizeRange(values);

    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.beginPath();

    values.forEach((v, i) => {
        const x = (i / (values.length - 1)) * width;
        const y = height - ((v - min) / (max - min)) * height;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
    });

    ctx.stroke();
    ctx.restore();
}
